/*
 * Copyright (c) by INFODATA-GROUP. All rights reserved.
 * No part of this publication may be reproduced, distributed,
 * or transmitted in any form or by any means, including photocopying, recording,
 * or other electronic or mechanical methods, without the prior written permission of the publisher,
 * except in the case of brief quotations embodied in critical
 * reviews and certain other noncommercial uses permitted by copyright law.
 *  author : vhe
 *  date : 02/03/2021 07:39
 */

import { CalendarSelection } from './calendar-selection';
import { CalendarTasksGroup } from '../calendar-tasks-group';
import { CalendarResourcesDay } from '../calendar-resources-day';
import { HourSelectionEvent } from './hour-selection-event';

export class ResourceDaySelectionEvent implements CalendarSelection {
  public cell: CalendarResourcesDay;
  public selection: HourSelectionEvent;

  constructor(cell: CalendarResourcesDay, hourSelection: HourSelectionEvent) {
    this.cell = cell;
    this.selection = hourSelection;
  }

  public getEnd(): Date {
    const date = new Date(this.cell.date);
    date.setHours(this.selection.end.hours, this.selection.end.minutes);
    return date;
  }

  public getStart(): Date {
    const date = new Date(this.cell.date);
    date.setHours(this.selection.start.hours, this.selection.start.minutes);
    return date;
  }

  public getResource(): CalendarTasksGroup {
    return this.selection.resource;
  }

  public getPosition(): { x: number; y: number } {
    return { x: this.selection.event.x, y: this.selection.event.y };
  }

  public setResource(resource: CalendarTasksGroup) {
    this.selection.resource = resource;
  }

  public getEvent(): MouseEvent {
    return this.selection.event;
  }
}
